<template>
  <!-- 双人PK游戏主容器 -->
  <div class="pk-game-race">
    <!-- 倒计时覆盖层 -->
    <div v-if="gameState === 'countdown'" class="countdown-overlay">
      <div class="countdown-number" :class="{ animate: countdownAnimating }">
        {{ countdownNumber === 0 ? "开始!" : countdownNumber }}
      </div>
    </div>
    <!-- 游戏头部区域（水果忍者单人全屏模式不显示顶部玩家栏） -->
    <div v-if="!isRaceMode && selectedQuestionType !== 'wordNinja'">
      <div class="game-header game-header-bg">
        <!-- 玩家1头部信息 -->
        <div class="player-header one-flex_race one-header">
          <div class="player-header-img header-one">
            <img :src="require('@/assets/touxiang1.png')" alt="" />
          </div>
          <div class="player-header-name-one_race">
            <span>玩家1</span>
            <span>：</span>
            <span class="player-score race-score" v-if="selectedGameMode === 'timeLimit'">
              {{ questions.length > 0 ? questions.length + " / " + player1Score : player1Score }}
            </span>
            <span class="player-score race-score" v-if="selectedGameMode === 'timeTrack'">
              {{ formatTime(player1Time) }}
            </span>
            <span class="player-score race-score" v-if="selectedGameMode === 'scoreOnly'"> {{ player1Sum }}分 </span>
          </div>
          <!-- 不同游戏模式下显示不同的分数 -->
        </div>
        <!-- 游戏信息区域 -->
        <div
          class="game-info"
          :class="{
            'game-info-xs': selectedGameMode === 'timeLimit',
            'game-info-js': selectedGameMode === 'timeTrack',
            'game-info-jf': selectedGameMode === 'scoreOnly',
          }"
        >
          <!-- 不同游戏模式下显示不同的计时器 -->
          <div v-if="selectedGameMode === 'timeLimit' && selectedQuestionType !== 'wordNinja'" class="timer">
            {{ formatTime(remainingTime) }}
          </div>
          <div v-if="selectedGameMode === 'timeTrack' || selectedQuestionType === 'wordNinja'" class="timer">
            {{ formatTime(elapsedTime) }}
          </div>
          <div v-if="selectedGameMode === 'scoreOnly'" class="timer">
            {{ formatTime(remainingTime) }}
          </div>
          <div v-if="selectedGameMode === 'quickAnswer'" class="timer">
            {{ formatTime(elapsedTime) }}
          </div>
        </div>
        <!-- 玩家2头部信息 -->
        <div class="player-header two-flex_race two-header">
          <div class="player-header-name-two_race">
            <!-- 不同游戏模式下显示不同的分数 -->
            <span class="player-score race-score" v-if="selectedGameMode === 'timeLimit'">
              {{ questions.length > 0 ? player2Score + " / " + questions.length : player2Score }}
            </span>
            <span class="player-score race-score" v-if="selectedGameMode === 'timeTrack'">
              {{ formatTime(player2Time) }}
            </span>
            <span class="player-score" v-if="selectedGameMode === 'scoreOnly'">
              <span class="race-score">{{ player2Sum }}</span
              >分
            </span>
            <span>:</span>
            <span>2玩家</span>
          </div>
          <div class="player-header-img header-two">
            <img :src="require('@/assets/touxiang2.png')" alt="" />
          </div>
        </div>
      </div>
    </div>
    <div class="race-game-header-screen" v-if="isRaceMode">
      <div class="game-header">
        <!-- 玩家1头部信息 -->
        <div class="player-header one-flex_race one-header">
          <div class="player-header-img header-one">
            <img :src="require('@/assets/touxiang1.png')" alt="" />
          </div>
          <div class="player-header-name-one_race">
            <span>玩家1</span>
            <span>：</span>
            <span class="race-score">{{ player1Score }}</span>
            <span>分</span>
          </div>
        </div>
        <!-- 游戏信息区域 -->
        <div class="game-info game-info-qd"></div>
        <!-- 玩家2头部信息 -->
        <div class="player-header two-flex_race two-header">
          <div class="player-header-name-two_race">
            <span class="race-score">{{ player2Score }}</span>
            <span>分</span>
            <span>：</span>
            <span>2玩家</span>
          </div>
          <!-- 不同游戏模式下显示不同的分数 -->
          <div class="player-header-img header-two">
            <img :src="require('@/assets/touxiang2.png')" alt="" />
          </div>
        </div>
      </div>
    </div>
    <!-- 游戏主屏幕 -->
    <div class="game-screen">
      <!-- 结果展示区域（双人 PK；水果忍者成绩以弹窗展示） -->
      <div v-if="gameState === 'results' && selectedQuestionType !== 'wordNinja'" class="players-container">
        <!-- 玩家1结果 -->
        <div class="player-result player-one-result">
          <div
            class="player-result-css"
            :class="{
              'player-result-win': winner === 'player1',
              'player-result-lose': winner === 'player2',
              'player-result-tie': winner === 'tie',
            }"
          ></div>
          <div class="result-stats player-result-one">
            <div class="result-stat">
              <div>答对</div>
              <span>{{ player1Score }}</span> 题
            </div>
            <div v-if="selectedGameMode === 'timeTrack'" class="result-stat">
              用时{{ formatTime(player1Time, true) }}
            </div>
            <div class="result-stat" v-if="selectedGameMode === 'scoreOnly'">
              <span>{{ player1Sum }}</span> 分
            </div>
          </div>
        </div>
        <!-- 玩家2结果 -->
        <div class="player-result player-two-result">
          <div
            class="player-result-css"
            :class="{
              'player-result-win': winner === 'player2',
              'player-result-lose': winner === 'player1',
              'player-result-tie': winner === 'tie',
            }"
          ></div>
          <div class="result-stats player-result-two">
            <div class="result-stat">
              <div>答对</div>
              <span>{{ player2Score }}</span> 题
            </div>
            <div v-if="selectedGameMode === 'timeTrack'" class="result-stat">
              用时{{ formatTime(player2Time, true) }}
            </div>
            <div class="result-stat" v-if="selectedGameMode === 'scoreOnly'">
              <span>{{ player2Sum }}</span> 分
            </div>
          </div>
        </div>
      </div>
      <!-- 游戏进行区域 -->
      <div v-else>
        <div
          class="game-area"
          v-if="
            (gameState == 'playing' && selectedQuestionType == 'wordSpell') ||
            (gameState == 'playing' && selectedQuestionType == 'wordCorrect')
          "
        >
          <!-- 拼写 -->
          <div class="game-word-container">
            <div class="container-center-mode">
              <div class="mode-title" v-if="!raceHasCheckedType && selectedQuestionType === 'wordSpell'">纠错抢答</div>
              <div class="mode-desc" v-if="selectedQuestionType === 'wordCorrect'">点击错误的字母并纠正</div>
              <div class="mode-desc" v-if="selectedQuestionType === 'wordSpell'">判断拼写对错并纠正</div>
              <div v-if="!raceHasCheckedType">
                <div
                  :class="{
                    'mode-english': wordPosition === 1,
                    'mode-chinese': wordPosition === -1,
                  }"
                >
                  {{ raceEnglishWord }}
                </div>
                <div
                  :class="{
                    'mode-chinese': wordPosition === 1,
                    'mode-english': wordPosition === -1,
                  }"
                >
                  {{ raceChineseWord }}
                </div>
              </div>
            </div>
            <div class="container-player-mode players-container">
              <div class="player-section">
                <div class="question-container">
                  <div
                    class="question-text question-text_left"
                    @click="racePlayerData('1')"
                    v-if="!raceHasCheckedType && selectedQuestionType === 'wordCorrect'"
                  >
                    <span class="question-text-english">抢</span>
                  </div>
                  <div
                    class="question-btn-container"
                    v-if="!raceHasCheckedType && selectedQuestionType === 'wordSpell'"
                  >
                    <span class="question-btn-text yes-btn" @click="submitAnswer(1, 'yes')"
                      >对
                      <transition name="score-fade">
                        <span
                          v-if="player1ScoreAnimation.show && player1ScoreAnimation.source === 'button'"
                          class="score-animation"
                          :class="player1ScoreAnimation.type"
                        >
                          {{ player1ScoreAnimation.value }}
                        </span>
                      </transition>
                    </span>
                    <span class="question-btn-text on-btn" @click="racePlayerData('1')">错</span>
                  </div>
                  <div class="question-word-btn" v-if="raceHasCheckedType === '1'">
                    <!-- 确认按钮提交后的分数动画 -->
                    <transition name="score-fade">
                      <span
                        v-if="
                          player1ScoreAnimation.show &&
                          raceHasCheckedType === '1' &&
                          player1ScoreAnimation.source === 'keyboard'
                        "
                        class="score-animation word-score-animation"
                        :class="player1ScoreAnimation.type"
                      >
                        {{ player1ScoreAnimation.value }}
                      </span>
                    </transition>
                    <div class="word-container">
                      <div v-if="wordPosition === 1">
                        <div class="word-down-second">{{ answerCountNumber }}秒</div>
                        <div class="word-display">
                          <div
                            v-for="(letter, index) in player1DisplayWord"
                            :key="'p1-letter-' + index"
                            class="letter-box word-item-box"
                            :class="{
                              'player1-selected': player1Selections[index],
                              'active-position-race': player1SelectedPosition === index,
                              'correct-answer_race': player1AnswerSubmitted && player1Correct,
                              'incorrect-answer_race': player1AnswerSubmitted && !player1Correct,
                            }"
                            @click="selectPosition(1, index)"
                          >
                            <span>{{ letter }}</span>
                          </div>
                        </div>
                        <div class="word-chinese">{{ raceChineseWord }}</div>
                      </div>
                      <div v-if="wordPosition === -1">
                        <div class="word-down-second">{{ answerCountNumber }}秒</div>
                        <div class="word-chinese">{{ raceEnglishWord }}</div>
                        <div class="word-display">
                          <div
                            v-for="(letter, index) in player1DisplayWord"
                            :key="'p1-letter-' + index"
                            class="letter-box word-item-box"
                            :class="{
                              'player1-selected': player1Selections[index],
                              'active-position-race': player1SelectedPosition === index,
                              'correct-answer_race': player1AnswerSubmitted && player1Correct,
                              'incorrect-answer_race': player1AnswerSubmitted && !player1Correct,
                            }"
                            @click="selectPosition(1, index)"
                          >
                            <span>{{ letter }}</span>
                          </div>
                        </div>
                      </div>
                      <!-- <p class="countdown-message" v-if="player1Correct">
                        {{
                          player1NextWordCountdown > 0
                            ? `${player1NextWordCountdown}秒后下一题...`
                            : "加载中..."
                        }}
                      </p> -->
                    </div>
                  </div>
                </div>
              </div>
              <div class="player-section">
                <div class="question-container">
                  <div
                    class="question-text question-text_right"
                    @click="racePlayerData('2')"
                    v-if="!raceHasCheckedType && selectedQuestionType === 'wordCorrect'"
                  >
                    <span class="question-text-english">抢</span>
                  </div>
                  <div
                    class="question-btn-container"
                    v-if="!raceHasCheckedType && selectedQuestionType === 'wordSpell'"
                  >
                    <span class="question-btn-text yes-btn" @click="submitAnswer(2, 'yes')"
                      >对
                      <transition name="score-fade">
                        <span
                          v-if="player2ScoreAnimation.show && player2ScoreAnimation.source === 'button'"
                          class="score-animation"
                          :class="player2ScoreAnimation.type"
                        >
                          {{ player2ScoreAnimation.value }}
                        </span>
                      </transition>
                    </span>
                    <span class="question-btn-text on-btn" @click="racePlayerData('2')">错</span>
                  </div>
                  <div class="question-word-btn" v-if="raceHasCheckedType === '2'">
                    <!-- 确认按钮提交后的分数动画 -->
                    <transition name="score-fade">
                      <span
                        v-if="
                          player2ScoreAnimation.show &&
                          raceHasCheckedType === '2' &&
                          player2ScoreAnimation.source === 'keyboard'
                        "
                        class="score-animation word-score-animation"
                        :class="player2ScoreAnimation.type"
                      >
                        {{ player2ScoreAnimation.value }}
                      </span>
                    </transition>
                    <div class="word-container">
                      <div v-if="wordPosition === 1">
                        <div class="word-down-second">{{ answerCountNumber }}秒</div>
                        <div class="word-display">
                          <div
                            v-for="(letter, index) in player2DisplayWord"
                            :key="'p2-letter-' + index"
                            class="letter-box word-item-box"
                            :class="{
                              'player2-selected': player2Selections[index],
                              'active-position-race': player2SelectedPosition === index,
                              'correct-answer_race': player2AnswerSubmitted && player2Correct,
                              'incorrect-answer_race': player2AnswerSubmitted && !player2Correct,
                            }"
                            @click="selectPosition(2, index)"
                          >
                            <span>{{ letter }}</span>
                          </div>
                        </div>
                        <div class="word-chinese">{{ raceChineseWord }}</div>
                      </div>
                      <div v-if="wordPosition === -1">
                        <div class="word-down-second">{{ answerCountNumber }}秒</div>
                        <div class="word-chinese">{{ raceEnglishWord }}</div>
                        <div class="word-display">
                          <div
                            v-for="(letter, index) in player2DisplayWord"
                            :key="'p2-letter-' + index"
                            class="letter-box word-item-box"
                            :class="{
                              'player2-selected': player2Selections[index],
                              'active-position-race': player2SelectedPosition === index,
                              'correct-answer_race': player2AnswerSubmitted && player2Correct,
                              'incorrect-answer_race': player2AnswerSubmitted && !player2Correct,
                            }"
                            @click="selectPosition(2, index)"
                          >
                            <span>{{ letter }}</span>
                          </div>
                        </div>
                      </div>
                      <!-- <p class="countdown-message" v-if="player2Correct">
                        {{
                          player2NextWordCountdown > 0
                            ? `${player2NextWordCountdown}秒后下一题...`
                            : "加载中..."
                        }}
                      </p> -->
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="key-board-container">
              <div class="key-board-player1 pad-l-100">
                <div
                  v-if="player1SelectedPosition !== null && !player1AnswerSubmitted"
                  class="player1-keyboard keyboard-container"
                >
                  <!-- First row: Q-P + Delete -->
                  <div class="keyboard-row">
                    <div v-for="letter in keyboardLayout[0]" :key="'p1-key-' + letter" class="keyboard-key-wrapper">
                      <button
                        type="button"
                        @click="handleRaceClick(1, letter)"
                        class="keyboard-key player1-key"
                        :class="{
                          'player1-selected': player1Selections[player1SelectedPosition] === letter,
                        }"
                      >
                        {{ letter }}
                      </button>
                    </div>
                    <!-- Delete Key -->
                    <div class="keyboard-key-wrapper delete-wrapper">
                      <button
                        @click="handleDeleteKey(1)"
                        class="delete-key player1-delete"
                        :disabled="!player1Selections[player1SelectedPosition]"
                        :class="{
                          disabled: !player1Selections[player1SelectedPosition],
                        }"
                      >
                        ←
                      </button>
                    </div>
                  </div>

                  <!-- Second row: A-L -->
                  <div class="keyboard-row">
                    <div v-for="letter in keyboardLayout[1]" :key="'p1-key-' + letter" class="keyboard-key-wrapper">
                      <button
                        type="button"
                        @click="handleRaceClick(1, letter)"
                        class="keyboard-key player1-key"
                        :class="{
                          'player1-selected': player1Selections[player1SelectedPosition] === letter,
                        }"
                      >
                        {{ letter }}
                      </button>
                    </div>
                  </div>

                  <!-- Third row: Z-M + Confirm -->
                  <div class="keyboard-row">
                    <div v-for="letter in keyboardLayout[2]" :key="'p1-key-' + letter" class="keyboard-key-wrapper">
                      <button
                        type="button"
                        @click="handleRaceClick(1, letter)"
                        class="keyboard-key player1-key"
                        :class="{
                          'player1-selected': player1Selections[player1SelectedPosition] === letter,
                        }"
                      >
                        {{ letter }}
                      </button>
                    </div>
                    <!-- Confirm Button -->
                    <div class="keyboard-key-wrapper confirm-wrapper">
                      <button
                        @click="submitAnswer(1)"
                        class="confirm-key player1-confirm"
                        :disabled="!isPlayerAnswerComplete(1)"
                        :class="{ disabled: !isPlayerAnswerComplete(1) }"
                      >
                        确认
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="key-board-player2 pad-r-100">
                <div
                  v-if="player2SelectedPosition !== null && !player2AnswerSubmitted"
                  class="player2-keyboard keyboard-container"
                >
                  <!-- First row: Q-P + Delete -->
                  <div class="keyboard-row">
                    <div v-for="letter in keyboardLayout[0]" :key="'p2-key-' + letter" class="keyboard-key-wrapper">
                      <button
                        type="button"
                        @click="handleRaceClick(2, letter)"
                        class="keyboard-key player2-key"
                        :class="{
                          'player2-selected': player2Selections[player2SelectedPosition] === letter,
                        }"
                      >
                        {{ letter }}
                      </button>
                    </div>
                    <!-- Delete Key -->
                    <div class="keyboard-key-wrapper delete-wrapper">
                      <button
                        @click="handleDeleteKey(2)"
                        class="delete-key player2-delete"
                        :disabled="!player2Selections[player2SelectedPosition]"
                        :class="{
                          disabled: !player2Selections[player2SelectedPosition],
                        }"
                      >
                        ←
                      </button>
                    </div>
                  </div>

                  <!-- Second row: A-L -->
                  <div class="keyboard-row">
                    <div v-for="letter in keyboardLayout[1]" :key="'p2-key-' + letter" class="keyboard-key-wrapper">
                      <button
                        type="button"
                        @click="handleRaceClick(2, letter)"
                        class="keyboard-key player2-key"
                        :class="{
                          'player2-selected': player2Selections[player2SelectedPosition] === letter,
                        }"
                      >
                        {{ letter }}
                      </button>
                    </div>
                  </div>
                  <!-- Third row: Z-M + Confirm -->
                  <div class="keyboard-row">
                    <div v-for="letter in keyboardLayout[2]" :key="'p2-key-' + letter" class="keyboard-key-wrapper">
                      <button
                        type="button"
                        @click="handleRaceClick(2, letter)"
                        class="keyboard-key player2-key"
                        :class="{
                          'player2-selected': player2Selections[player2SelectedPosition] === letter,
                        }"
                      >
                        {{ letter }}
                      </button>
                    </div>
                    <!-- Confirm Button -->
                    <div class="keyboard-key-wrapper confirm-wrapper">
                      <button
                        @click="submitAnswer(2)"
                        class="confirm-key player2-confirm"
                        :disabled="!isPlayerAnswerComplete(2)"
                        :class="{ disabled: !isPlayerAnswerComplete(2) }"
                      >
                        确认
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="game-rule-change" v-if="!raceHasCheckedType && selectedQuestionType === 'wordSpell'">
              <div class="change-btn">
                <span>单词位置:</span>
                <span
                  class="change-btn-item"
                  :class="{ 'change-btn-item-active': wordPosition === 1 }"
                  @click="changePosition(1)"
                  >上</span
                >
                <span
                  class="change-btn-item"
                  :class="{ 'change-btn-item-active': wordPosition === -1 }"
                  @click="changePosition(-1)"
                  >下</span
                >
              </div>
              <div class="chang-score"><span>答对：</span><span>1分</span></div>
            </div>
          </div>
        </div>
        <div class="game-area" v-else-if="gameState == 'playing' && selectedQuestionType === 'wordPair'">
          <div class="game-area-container">
            <div class="player-areas">
              <!-- Player 1 Area -->
              <div class="player1-area" style="overflow: hidden">
                <div class="happy-game-container">
                  <div class="layer-info" v-if="happyGameData.player1 && !happyGameData.player1.completed">
                    第 {{ happyGameData.player1.currentLayerIndex + 1 }} / {{ happyGameData.player1.layers.length }} 组
                  </div>
                  <div
                    class="layer-grid"
                    v-if="
                      happyGameData.player1 &&
                      !happyGameData.player1.completed &&
                      happyGameData.player1.layers.length > 0
                    "
                  >
                    <div
                      v-for="(item, index) in happyGameData.player1.layers[happyGameData.player1.currentLayerIndex]"
                      :key="item.id"
                      class="happy-cube"
                      :class="item.status"
                      @touchstart.prevent.stop="handleHappyTouchSelect('player1', item, index, $event)"
                      @click.prevent.stop="handleHappyItemClick('player1', item, index)"
                    >
                      {{ item.content }}
                    </div>
                  </div>
                  <div class="player-status" v-if="happyGameData.player1 && happyGameData.player1.completed">
                    已完成所有题目!
                  </div>
                </div>
              </div>

              <!-- Player 2 Area -->
              <div class="player2-area" style="overflow: hidden">
                <div class="happy-game-container">
                  <div class="layer-info" v-if="happyGameData.player2 && !happyGameData.player2.completed">
                    第 {{ happyGameData.player2.currentLayerIndex + 1 }} / {{ happyGameData.player2.layers.length }} 组
                  </div>
                  <div
                    class="layer-grid"
                    v-if="
                      happyGameData.player2 &&
                      !happyGameData.player2.completed &&
                      happyGameData.player2.layers.length > 0
                    "
                  >
                    <div
                      v-for="(item, index) in happyGameData.player2.layers[happyGameData.player2.currentLayerIndex]"
                      :key="item.id"
                      class="happy-cube"
                      :class="item.status"
                      @touchstart.prevent.stop="handleHappyTouchSelect('player2', item, index, $event)"
                      @click.prevent.stop="handleHappyItemClick('player2', item, index)"
                    >
                      {{ item.content }}
                    </div>
                  </div>
                  <div class="player-status" v-if="happyGameData.player2 && happyGameData.player2.completed">
                    已完成所有题目!
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="game-area ninja-game-area" v-else-if="gameState == 'playing' && selectedQuestionType === 'wordNinja'">
          <div class="game-area-container">
            <div class="ninja-zone ninja-single">
              <!-- 顶部信息栏：左（进度/生命/连击）+ 居中目标词 -->
              <div class="ninja-hud">
                <div class="ninja-target-card" v-if="ninjaData.player1.targetList.length">
                  <div class="ninja-hud-left">
                    <div class="ninja-progress">
                      第 {{ Math.min(ninjaData.player1.targetIndex + 1, ninjaData.player1.targetList.length) }} /
                      {{ ninjaData.player1.targetList.length }} 题
                    </div>
                    <div class="ninja-hud-stats">
                      <span class="ninja-lives-num">❤️ {{ ninjaData.player1.lives }}</span>
                      <span
                        class="ninja-combo-num"
                        :class="{ hot: ninjaData.player1.combo >= 3 }"
                      >
                        🔥 x{{ ninjaData.player1.combo }}
                      </span>
                    </div>
                  </div>
                  <div class="ninja-target-center">
                    <span class="ninja-target-label">目标词</span>
                    <span class="ninja-target-word">{{
                      ninjaData.player1.targetList[ninjaData.player1.targetIndex]
                        ? ninjaData.player1.targetList[ninjaData.player1.targetIndex].chinese
                        : ""
                    }}</span>
                  </div>
                  <!-- 正计时（顶部玩家栏已隐藏，计时显示在卡片右侧） -->
                  <div class="ninja-hud-timer">
                    <span class="ninja-hud-timer-icon">⏱</span>
                    <span class="ninja-hud-timer-num">{{ formatTime(elapsedTime) }}</span>
                  </div>
                </div>
              </div>
              <!-- 游戏场地：水果 / 粒子 / 刀光 / 连击（支持点击 + 滑动切割） -->
              <div
                class="ninja-field"
                ref="ninjaField"
                @touchstart="ninjaSwipeReset('player1')"
                @touchmove.prevent="handleNinjaSwipe('player1', $event)"
                @touchend="ninjaSwipeReset('player1')"
                @touchcancel="ninjaSwipeReset('player1')"
                @mousedown="ninjaMouseDragStart('player1')"
                @mousemove="handleNinjaMouseDrag('player1', $event)"
                @mouseup="ninjaMouseDragEnd('player1')"
                @mouseleave="ninjaMouseDragEnd('player1')"
              >
                <div
                  v-for="fruit in ninjaData.player1.fruits"
                  :key="fruit.id"
                  class="ninja-fruit"
                  :class="'ninja-fruit-c' + fruit.colorIndex"
                  :style="{
                    width: fruit.size + 'px',
                    height: fruit.size + 'px',
                    transform: 'translate(' + (fruit.x - fruit.size / 2) + 'px,' + (fruit.y - fruit.size / 2) + 'px)',
                  }"
                  @touchstart.prevent.stop="handleNinjaSlice('player1', fruit, $event)"
                  @click.stop="handleNinjaSlice('player1', fruit, $event)"
                >
                  <span
                    class="ninja-fruit-word"
                    :class="{ 'ninja-fruit-word-target': fruit.isTarget }"
                    :style="{ fontSize: fruit.fontSize + 'px' }"
                    >{{ fruit.english }}</span
                  >
                </div>
                <div
                  v-for="pt in ninjaData.player1.particles"
                  :key="pt.id"
                  class="ninja-particle"
                  :style="{
                    width: pt.size + 'px',
                    height: pt.size + 'px',
                    left: pt.x - pt.size / 2 + 'px',
                    top: pt.y - pt.size / 2 + 'px',
                    background: pt.color,
                    transform: pt.flying
                      ? 'translate(' + pt.dx + 'px,' + pt.dy + 'px) scale(0.15)'
                      : 'translate(0,0) scale(1)',
                    opacity: pt.flying ? 0 : 1,
                  }"
                ></div>
                <div
                  v-for="s in ninjaData.player1.slashes"
                  :key="s.id"
                  class="ninja-slash"
                  :style="{ left: s.x + 'px', top: s.y + 'px', transform: 'rotate(' + s.rot + 'deg)' }"
                ></div>
                <div v-if="ninjaData.player1.comboFlash" class="ninja-combo-flash">
                  {{ ninjaData.player1.comboFlash }} 连击!
                </div>
                <div v-if="ninjaData.player1.failFlash" class="ninja-fail-overlay"></div>
              </div>
            </div>
          </div>
        </div>
        <div class="game-area" v-else-if="gameState == 'playing' && selectedQuestionType === 'letter'">
          <div class="game-area-container">
            <div class="player-areas">
              <!-- Player 1 Area -->
              <div class="player1-area">
                <!-- Chinese meaning for Player 1 -->
                <div class="chinese-meaning" v-if="gameState === 'playing'">
                  <p class="meaning-text">
                    <span class="meaning-value">{{ getChineseMeaning(player1Word) }}</span>
                  </p>
                </div>

                <!-- Word display for Player 1 -->
                <div class="word-container">
                  <div class="word-display">
                    <div
                      v-for="(letter, index) in player1DisplayWord"
                      :key="'p1-letter-' + index"
                      class="letter-box"
                      :class="{
                        filled: letter !== '_',
                        missing: letter === '_' && !player1Selections[index],
                        'player1-selected': player1Selections[index],
                        'correct-answer': player1AnswerSubmitted && player1Correct,
                        'incorrect-answer': player1AnswerSubmitted && !player1Correct,
                        'active-position': player1SelectedPosition === index,
                      }"
                      @click="letter === '_' ? selectPosition(1, index, true, 2) : null"
                    >
                      <span v-if="letter !== '_'">{{ letter }}</span>
                      <span v-else-if="player1Selections[index]">{{ player1Selections[index] }}</span>
                      <span v-else> </span>
                    </div>
                  </div>
                </div>
                <!-- Keyboard prompt when no position is selected -->
                <div
                  v-if="player1SelectedPosition === null && !player1AnswerSubmitted"
                  class="keyboard-prompt player1-prompt"
                >
                  <div v-if="gameState !== 'playing'">
                    <div class="prompt-img player1-img">字母归位</div>
                    <div class="setup-message">
                      <!-- 请在右下角设置游戏选项，然后点击"开始比赛" -->
                    </div>
                  </div>
                  <!-- <p>先点击位置错误的字母，再填入正确的字母</p> -->
                </div>

                <!-- Player 1 Feedback -->
                <div
                  v-if="player1AnswerSubmitted && !player1Completed"
                  class="feedback"
                  :class="{
                    'correct-feedback': player1Correct,
                    'incorrect-feedback': !player1Correct,
                  }"
                >
                  <p v-if="player1Correct" class="correct-message">正确！</p>
                  <p v-else class="incorrect-message">
                    <span v-if="selectedGameMode === 'scoreOnly'">
                      {{ `错误！${player1Sum > 0 ? "扣5分" : ""} 正确单词: ${player1Word}` }}
                    </span>
                    <span v-else-if="selectedGameMode === 'timeTrack'"> 错误！加2秒。正确单词: {{ player1Word }} </span>
                    <span v-else> 错误！正确单词: {{ player1Word }} </span>
                  </p>
                  <p class="countdown-message">
                    {{ player1NextWordCountdown > 0 ? `${player1NextWordCountdown}秒后下一题...` : "加载中..." }}
                  </p>
                </div>
                <div class="player-status" v-if="player1Completed">已完成所有题目!</div>
              </div>
              <!-- Player 2 Area -->
              <div class="player2-area">
                <!-- Chinese meaning for Player 2 -->
                <div class="chinese-meaning" v-if="gameState === 'playing'">
                  <p class="meaning-text">
                    <span class="meaning-value">{{ getChineseMeaning(player2Word) }}</span>
                  </p>
                </div>

                <!-- Word display for Player 2 -->
                <div class="word-container">
                  <div class="word-display">
                    <div
                      v-for="(letter, index) in player2DisplayWord"
                      :key="'p2-letter-' + index"
                      class="letter-box"
                      :class="{
                        filled: letter !== '_',
                        missing: letter === '_' && !player2Selections[index],
                        'player2-selected': player2Selections[index],
                        'correct-answer': player2AnswerSubmitted && player2Correct,
                        'incorrect-answer': player2AnswerSubmitted && !player2Correct,
                        'active-position': player2SelectedPosition === index,
                      }"
                      @click="letter === '_' ? selectPosition(2, index, true, 2) : null"
                    >
                      <span v-if="letter !== '_'">{{ letter }}</span>
                      <span v-else-if="player2Selections[index]">{{ player2Selections[index] }}</span>
                      <span v-else> </span>
                    </div>
                  </div>
                </div>

                <!-- Keyboard prompt when no position is selected -->
                <div
                  v-if="player2SelectedPosition === null && !player2AnswerSubmitted"
                  class="keyboard-prompt player2-prompt"
                >
                  <div v-if="gameState !== 'playing'">
                    <div class="prompt-img player1-img">字母归位</div>
                    <div class="setup-message">
                      <!-- 请在右下角设置游戏选项，然后点击"开始比赛" -->
                    </div>
                  </div>
                  <!-- <p>先点击位置错误的字母，再填入正确的字母</p> -->
                </div>
                <!-- Player 2 Feedback -->
                <div
                  v-if="player2AnswerSubmitted && !player2Completed"
                  class="feedback"
                  :class="{
                    'correct-feedback': player2Correct,
                    'incorrect-feedback': !player2Correct,
                  }"
                >
                  <p v-if="player2Correct" class="correct-message">正确！</p>
                  <p v-else class="incorrect-message">
                    <span v-if="selectedGameMode === 'scoreOnly'">
                      {{ `错误！${player2Sum > 0 ? "扣5分" : ""} 正确单词: ${player2Word}` }}
                    </span>
                    <span v-else-if="selectedGameMode === 'timeTrack'"> 错误！加2秒。正确单词: {{ player2Word }} </span>
                    <span v-else> 错误！正确单词: {{ player2Word }} </span>
                  </p>
                  <p class="countdown-message">
                    {{ player2NextWordCountdown > 0 ? `${player2NextWordCountdown}秒后下一题...` : "加载中..." }}
                  </p>
                </div>
                <div class="player-status" v-if="player2Completed">已完成所有题目!</div>
              </div>
            </div>
            <div class="key-board-container">
              <div class="key-board-player1">
                <div
                  v-if="player1SelectedPosition !== null && !player1AnswerSubmitted"
                  class="player1-keyboard keyboard-container"
                >
                  <!-- First row: Q-P + Delete -->
                  <div class="keyboard-row">
                    <div v-for="letter in keyboardLayout[0]" :key="'p1-key-' + letter" class="keyboard-key-wrapper">
                      <button
                        type="button"
                        @click="handleLetterClick(1, letter)"
                        class="keyboard-key player1-key"
                        :class="{
                          'player1-selected': player1Selections[player1SelectedPosition] === letter,
                        }"
                      >
                        {{ letter }}
                      </button>
                    </div>
                    <!-- Delete Key -->
                    <div class="keyboard-key-wrapper delete-wrapper">
                      <button
                        @click="handleDeleteKey(1)"
                        class="delete-key player1-delete"
                        :disabled="!player1Selections[player1SelectedPosition]"
                        :class="{
                          disabled: !player1Selections[player1SelectedPosition],
                        }"
                      >
                        ←
                      </button>
                    </div>
                  </div>

                  <!-- Second row: A-L -->
                  <div class="keyboard-row">
                    <div v-for="letter in keyboardLayout[1]" :key="'p1-key-' + letter" class="keyboard-key-wrapper">
                      <button
                        type="button"
                        @click="handleLetterClick(1, letter)"
                        class="keyboard-key player1-key"
                        :class="{
                          'player1-selected': player1Selections[player1SelectedPosition] === letter,
                        }"
                      >
                        {{ letter }}
                      </button>
                    </div>
                  </div>

                  <!-- Third row: Z-M + Confirm -->
                  <div class="keyboard-row">
                    <div v-for="letter in keyboardLayout[2]" :key="'p1-key-' + letter" class="keyboard-key-wrapper">
                      <button
                        type="button"
                        @click="handleLetterClick(1, letter)"
                        class="keyboard-key player1-key"
                        :class="{
                          'player1-selected': player1Selections[player1SelectedPosition] === letter,
                        }"
                      >
                        {{ letter }}
                      </button>
                    </div>
                    <!-- Confirm Button -->
                    <div class="keyboard-key-wrapper confirm-wrapper">
                      <button
                        @click="submitAnswer(1)"
                        class="confirm-key player1-confirm"
                        :disabled="!isPlayerAnswerComplete(1)"
                        :class="{ disabled: !isPlayerAnswerComplete(1) }"
                      >
                        确认
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="key-board-player2">
                <div
                  v-if="player2SelectedPosition !== null && !player2AnswerSubmitted"
                  class="player2-keyboard keyboard-container"
                >
                  <!-- First row: Q-P + Delete -->
                  <div class="keyboard-row">
                    <div v-for="letter in keyboardLayout[0]" :key="'p2-key-' + letter" class="keyboard-key-wrapper">
                      <button
                        type="button"
                        @click="handleLetterClick(2, letter)"
                        class="keyboard-key player2-key"
                        :class="{
                          'player2-selected': player2Selections[player2SelectedPosition] === letter,
                        }"
                      >
                        {{ letter }}
                      </button>
                    </div>
                    <!-- Delete Key -->
                    <div class="keyboard-key-wrapper delete-wrapper">
                      <button
                        @click="handleDeleteKey(2)"
                        class="delete-key player2-delete"
                        :disabled="!player2Selections[player2SelectedPosition]"
                        :class="{
                          disabled: !player2Selections[player2SelectedPosition],
                        }"
                      >
                        ←
                      </button>
                    </div>
                  </div>

                  <!-- Second row: A-L -->
                  <div class="keyboard-row">
                    <div v-for="letter in keyboardLayout[1]" :key="'p2-key-' + letter" class="keyboard-key-wrapper">
                      <button
                        type="button"
                        @click="handleLetterClick(2, letter)"
                        class="keyboard-key player2-key"
                        :class="{
                          'player2-selected': player2Selections[player2SelectedPosition] === letter,
                        }"
                      >
                        {{ letter }}
                      </button>
                    </div>
                  </div>
                  <!-- Third row: Z-M + Confirm -->
                  <div class="keyboard-row">
                    <div v-for="letter in keyboardLayout[2]" :key="'p2-key-' + letter" class="keyboard-key-wrapper">
                      <button
                        type="button"
                        @click="handleLetterClick(2, letter)"
                        class="keyboard-key player2-key"
                        :class="{
                          'player2-selected': player2Selections[player2SelectedPosition] === letter,
                        }"
                      >
                        {{ letter }}
                      </button>
                    </div>
                    <!-- Confirm Button -->
                    <div class="keyboard-key-wrapper confirm-wrapper">
                      <button
                        @click="submitAnswer(2)"
                        class="confirm-key player2-confirm"
                        :disabled="!isPlayerAnswerComplete(2)"
                        :class="{ disabled: !isPlayerAnswerComplete(2) }"
                      >
                        确认
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else class="players-container">
          <!-- 玩家1区域 -->
          <div
            class="player-section player-one"
            :class="{
              'player-completed': player1Completed,
              disabled: gameState !== 'playing',
            }"
          >
            <div class="question-container">
              <!-- 游戏进行中显示问题 -->
              <div v-if="gameState === 'playing'">
                <div class="question">
                  {{ questions[player1CurrentQuestion] ? questions[player1CurrentQuestion].question : "" }}
                </div>
              </div>
              <!-- 非游戏状态显示设置提示 -->
              <div v-else class="setup-message">
                <!-- 请在右下角设置游戏选项，然后点击"开始比赛" -->
                <div class="setup-message-time" v-if="selectedGameMode === 'timeLimit'">
                  <!-- 在规定{{ timeMintute }}分钟内，答对多者赢，每题限选一次 -->
                </div>
                <div class="setup-message-time" v-if="selectedGameMode === 'timeTrack'">
                  <!-- 全部答对用时少者赢，选错 1 次加 2 秒 -->
                </div>
                <div class="setup-message-time" v-if="selectedGameMode === 'scoreOnly'">
                  <!-- 每题 10 分，答完分多者赢，每题限答 1 次，答错扣 5 分 -->
                </div>
              </div>

              <!-- 选项按钮区域 -->
              <div v-if="gameState === 'playing'" class="options-container player1-options">
                <button
                  v-for="(option, index) in questions[player1CurrentQuestion]
                    ? questions[player1CurrentQuestion].options
                    : []"
                  :key="index"
                  class="option-button option-button-one"
                  :class="{
                    correct:
                      player1AnsweredCurrent &&
                      player1SelectedOption === index &&
                      index === questions[player1CurrentQuestion].correctIndex,
                    incorrect:
                      player1AnsweredCurrent &&
                      player1SelectedOption === index &&
                      index !== questions[player1CurrentQuestion].correctIndex,
                    'option-size-1': getRandomSizeClass(index, player1CurrentQuestion) === 1,
                    'option-size-2': getRandomSizeClass(index, player1CurrentQuestion) === 2,
                    'option-size-3': getRandomSizeClass(index, player1CurrentQuestion) === 3,
                    'option-button-english': !isCurrentOptionsContainChinese(),
                  }"
                  :disabled="player1AnsweredCurrent && selectedGameMode !== 'timeTrack'"
                  @touchstart.prevent.stop="handleTouchSelect(0, index, $event)"
                  @click.prevent.stop="selectOption(0, index)"
                >
                  {{ option }}
                </button>
              </div>

              <!-- 玩家完成状态提示 -->
              <div class="player-status" v-if="player1Completed">已完成所有题目!</div>
            </div>
          </div>

          <!-- 玩家2区域 -->
          <div
            class="player-section player-two"
            :class="{
              'player-completed': player2Completed,
              disabled: gameState !== 'playing',
            }"
          >
            <div class="question-container">
              <!-- 游戏进行中显示问题 -->
              <div v-if="gameState === 'playing'" class="question other-style">
                {{ questions[player2CurrentQuestion] ? questions[player2CurrentQuestion].question : "" }}
              </div>
              <!-- 非游戏状态显示设置提示 -->
              <div v-else class="setup-message">
                <!-- 请在右下角设置游戏选项，然后点击"开始比赛" -->
                <div class="setup-message-time" v-if="selectedGameMode === 'timeLimit'">
                  <!-- 在规定{{ timeMintute }}分钟内，答对多者赢，每题限选一次 -->
                </div>
                <div class="setup-message-time" v-if="selectedGameMode === 'timeTrack'">
                  <!-- 全部答对用时少者赢，选错 1 次加 2 秒 -->
                </div>
                <div class="setup-message-time" v-if="selectedGameMode === 'scoreOnly'">
                  <!-- 每题 10 分，答完分多者赢，每题限答 1 次，答错扣 5 分 -->
                </div>
              </div>

              <!-- 选项按钮区域 -->
              <div v-if="gameState === 'playing'" class="options-container player2-options">
                <button
                  v-for="(option, index) in questions[player2CurrentQuestion]
                    ? questions[player2CurrentQuestion].options
                    : []"
                  :key="index"
                  class="option-button option-button-two"
                  :class="{
                    correct:
                      player2AnsweredCurrent &&
                      player2SelectedOption === index &&
                      index === questions[player2CurrentQuestion].correctIndex,
                    incorrect:
                      player2AnsweredCurrent &&
                      player2SelectedOption === index &&
                      index !== questions[player2CurrentQuestion].correctIndex,
                    'option-size-1': getRandomSizeClass(index, player2CurrentQuestion) === 1,
                    'option-size-2': getRandomSizeClass(index, player2CurrentQuestion) === 2,
                    'option-size-3': getRandomSizeClass(index, player2CurrentQuestion) === 3,
                    'option-button-english': !isCurrentOptionsContainChinese(),
                  }"
                  :disabled="player2AnsweredCurrent && selectedGameMode !== 'timeTrack'"
                  @touchstart.prevent.stop="handleTouchSelect(1, index, $event)"
                  @click.prevent.stop="selectOption(1, index)"
                >
                  {{ option }}
                </button>
              </div>

              <!-- 玩家完成状态提示 -->
              <div class="player-status" v-if="player2Completed">已完成所有题目!</div>
            </div>
          </div>
        </div>
      </div>
      <!-- 返回按钮 -->
      <button @click="backToSetup" class="options-toggle_refesh" aria-label="返回">
        <span class="options-icon">
          <img :src="require('@/assets/icon_left.png')" alt="" />
        </span>
      </button>
      <!-- 选项面板切换按钮 -->
      <button @click="toggleOptionsPanel" class="options-toggle" aria-label="显示或隐藏选项">
        <span class="options-icon" v-if="!optionsPanelVisible">
          <img :src="require('@/assets/icon_set.png')" alt="" />
        </span>
        <span class="options-icon" v-else>
          <img :src="require('@/assets/icon_guanbi.png')" alt="" />
        </span>
      </button>

      <!-- 胜利/失败弹窗（水果忍者，居中显示，内容居中） -->
      <div
        v-if="ninjaResultVisible && selectedQuestionType === 'wordNinja'"
        class="ninja-rank-dialog"
        @click.self="ninjaResultVisible = false"
      >
        <div class="ninja-rank-dialog-content ninja-result-dialog">
          <button class="ninja-rank-close" aria-label="关闭" @click="ninjaResultVisible = false">✕</button>
          <div class="ninja-result-banner" :class="ninjaGameResult === 'win' ? 'win' : 'lose'">
            <span class="ninja-result-banner-icon">{{ ninjaGameResult === "win" ? "🎉" : "💥" }}</span>
            <span class="ninja-result-banner-text">{{ ninjaGameResult === "win" ? "恭喜通关!" : "生命耗尽" }}</span>
          </div>
          <div class="ninja-result-stats">
            <div class="ninja-result-stat">
              <span class="ninja-result-num">{{ player1Score }}</span>
              <span class="ninja-result-label">切中词数</span>
            </div>
            <div class="ninja-result-stat">
              <span class="ninja-result-num">{{ player1Sum }}</span>
              <span class="ninja-result-label">总分</span>
            </div>
            <div class="ninja-result-stat">
              <span class="ninja-result-num">{{ formatTime(ninjaLastDuration) }}</span>
              <span class="ninja-result-label">用时</span>
            </div>
          </div>
        </div>
      </div>

      <!-- 忍者榜收起态：屏幕最右侧 🏆 切换按钮（小屏默认收起省空间） -->
      <div
        v-if="
          selectedQuestionType === 'wordNinja' &&
          (gameState === 'playing' || gameState === 'results') &&
          !ninjaRankVisible
        "
        class="ninja-rank-toggle"
        @click="ninjaRankVisible = true"
      >
        🏆
      </div>

      <!-- 忍者榜（屏幕最右侧，点击 🏆 展开面板，标题行 ✕ 收起） -->
      <div
        v-if="selectedQuestionType === 'wordNinja' && (gameState === 'playing' || gameState === 'results')"
        v-show="ninjaRankVisible"
        class="ninja-rank-panel"
      >
        <div class="ninja-rank-panel-title">
          🏆 忍者榜
          <span class="ninja-rank-panel-close" @click="ninjaRankVisible = false">✕</span>
        </div>
        <div v-if="!ninjaRankList.length" class="ninja-rank-panel-empty">暂无记录</div>
        <div v-else class="ninja-rank-panel-list">
          <div
            v-for="(item, index) in ninjaRankList"
            :key="index"
            class="ninja-rank-panel-item"
            :class="{ top: index === 0 }"
          >
            <span class="ninja-rank-panel-no">{{ index + 1 }}</span>
            <span class="ninja-rank-panel-score">{{ item.score }}分</span>
            <span class="ninja-rank-panel-time">{{ formatTime(item.time) }}</span>
          </div>
        </div>
      </div>

      <!-- 音效设置弹窗 -->
      <div v-if="soundSettingsVisible" class="sound-dialog">
        <div class="sound-dialog-content">
          <h3 class="sound-dialog-title">音效设置</h3>
          <div class="sound-setting-row">
            <span class="sound-setting-label">背景音乐</span>
            <button
              v-for="opt in bgmStyleOptions"
              :key="'bgm-' + opt.value"
              class="sound-option-btn"
              :class="{ active: soundSettings.bgm === opt.value }"
              @click="selectSoundStyle('bgm', opt.value)"
            >
              {{ opt.label }}
            </button>
          </div>
          <div class="sound-setting-row">
            <span class="sound-setting-label">答对音效</span>
            <button
              v-for="opt in correctSoundOptions"
              :key="'correct-' + opt.value"
              class="sound-option-btn"
              :class="{ active: soundSettings.correct === opt.value }"
              @click="selectSoundStyle('correct', opt.value)"
            >
              {{ opt.label }}
            </button>
          </div>
          <div class="sound-setting-row">
            <span class="sound-setting-label">答错音效</span>
            <button
              v-for="opt in wrongSoundOptions"
              :key="'wrong-' + opt.value"
              class="sound-option-btn"
              :class="{ active: soundSettings.wrong === opt.value }"
              @click="selectSoundStyle('wrong', opt.value)"
            >
              {{ opt.label }}
            </button>
          </div>
          <button @click="soundSettingsVisible = false" class="sound-dialog-close">完成</button>
        </div>
      </div>
      <!-- 出题选项面板 -->
      <div class="options-panel" :class="{ visible: optionsPanelVisible }">
        <!-- 出题类型选择 -->
        <div class="setup-section">
          <h3>出题选项</h3>
          <div class="radio-group">
            <div v-for="(type, index) in questionTypes" :key="index" class="radio-item">
              <input
                type="radio"
                :value="type.value"
                v-model="selectedQuestionType"
                :id="`question-type-${type.value}`"
                name="questionType"
                :disabled="gameState === 'playing' || gameState === 'countdown'"
              />
              <label :for="`question-type-${type.value}`">{{ type.label }}</label>
            </div>
          </div>
        </div>
        <!-- 比赛模式选择 -->
        <div class="setup-section">
          <!-- <h3 v-if="selectedQuestionType !== 'wordSpell'">比赛选项</h3> -->
          <h3>时间限定</h3>
          <div class="">
            <div v-for="(mode, index) in visibleGameModes" :key="index">
              <!-- <input
                type="radio"
                :value="mode.value"
                v-model="selectedGameMode"
                :id="`game-mode-${mode.value}`"
                name="gameMode"
                v-if="selectedQuestionType !== 'wordSpell'"
                :disabled="
                  gameState === 'playing' ||
                  gameState === 'countdown' ||
                  mode.disabled
                "
              /> -->
              <!-- <label
                :for="`game-mode-${mode.value}`"
                v-if="selectedQuestionType !== 'wordSpell'"
                >{{ mode.label }}</label
              > -->
              <!-- 时间限制模式的时间设置 -->
              <!-- <div
                v-if="mode.value === 'timeLimit' && optionsPanelVisible"
                class="section-time"
              > -->
              <div v-if="mode.value === 'timeLimit'" class="section-time">
                <i class="section-time-icon icon-jian" @click="triggerTime(false)"></i>
                <i class="time-span">{{ timeMintute }}分钟</i>
                <i class="section-time-icon icon-jia" @click="triggerTime(true)"></i>
              </div>
            </div>
          </div>

          <!-- Word Count Module -->
          <div style="margin-top: 15px; text-align: center">
            <h3 style="margin-bottom: 10px">词量限定</h3>
            <div class="section-time" style="justify-content: center">
              <i class="section-time-icon icon-jian" @click="triggerQuestionCount(false)"></i>
              <input
                type="number"
                v-model.number="questionCount"
                @blur="validateQuestionCount"
                class="section-question-count"
                :max="vocabulary.length"
                min="5"
              />
              <i class="section-time-icon icon-jia" @click="triggerQuestionCount(true)"></i>
            </div>
          </div>
        </div>

        <!-- 音效设置入口（文字按钮，位于开始比赛上方） -->
        <button
          v-if="gameState === 'setup' || gameState === 'results'"
          @click="soundSettingsVisible = true"
          class="sound-settings-text-btn"
        >
          音效设置
        </button>

        <!-- 开始比赛按钮 -->
        <button v-if="gameState === 'setup' || gameState === 'results'" @click="downStartGame" class="start-button">
          开始比赛
        </button>

        <!-- 重新开始按钮 -->
        <button v-if="gameState === 'playing'" @click="resetGameConfirm" class="reset-button">重新开始</button>
      </div>

      <!-- 确认对话框 -->
      <div v-if="showConfirmDialog" class="confirm-dialog">
        <div class="confirm-dialog-content">
          <p>确定要重新开始吗？当前进度将会丢失。</p>
          <div class="confirm-buttons">
            <button @click="cancelReset" class="cancel-button">取消</button>
            <button @click="confirmReset" class="confirm-button">确定</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// 导入游戏混入
import gameMixins from "./base/gameMixins";
import letterGameMixins from "./letterGame/letterGameMixins";
import raceWordMixins from "./raceWord/raceToCurrentMixins";
import bbHappyMixins from "./bbHappy/happy.js";
import gameAudioMixins from "@/mixins/gameAudioMixins";
import ninjaMixins from "./fruitNinja/ninjaMixins";
export default {
  name: "TwoPlayerPKGame",
  mixins: [gameMixins, letterGameMixins, raceWordMixins, bbHappyMixins, gameAudioMixins, ninjaMixins],
  computed: {
    visibleGameModes() {
      return this.gameModes.filter((mode) => !mode.disabled);
    },
  },
};
</script>

<style lang="less">
/* 导入基础样式 */
@import "./base/base.less";
@import "./letterGame/letterGameStyle.less";
@import "./raceWord/raceToCurrent.less";
@import "./bbHappy/happyStyle.less";
</style>
